import Vue from 'vue'
import Index from "./Index.vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

window._ = require('lodash');
require('../../core/dashboard-init');

Vue.use(ElementUI);

Vue.mixin({
    methods: {
        $trans(...args) {
            return window.$trans(...args)
        },
        route(...args) {
            return window.route(...args)
        },
        stripLegacySentinelPrices() {
            const selectedFilters = this.selectedFilters;
            let changed = false;

            ['min_price', 'max_price'].forEach((key) => {
                const value = Number(selectedFilters[key]);

                if (!Number.isNaN(value) && value >= 9999999) {
                    delete selectedFilters[key];
                    changed = true;
                }
            });

            Object.keys(selectedFilters).forEach((key) => {
                if (!key.startsWith('additional_data_max[')) {
                    return;
                }

                const value = Number(selectedFilters[key]);

                if (!Number.isNaN(value) && value >= 9999999) {
                    delete selectedFilters[key];
                    changed = true;
                }
            });

            if (changed) {
                const lang = document.querySelector('html').getAttribute('lang');
                const queryString = new URLSearchParams(selectedFilters).toString();
                const url = `/${lang}/products` + (queryString ? `?${queryString}` : '');
                history.replaceState({}, null, url);
            }
        },
    },
    computed: {
        selectedFilters() {
            try {
                const search = location.search.substring(1);

                return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            } catch (e) {
                return {};
            }
        },
    }
});

new Vue({
    el: '#mainShop',
    components: {
        'main-shop': Index,
    },
});
